import { DocumentStore } from './DocumentStore'
import { JSONDocument, JSONDocumentFormat } from './JSONDocument'

export class SpectralRulesetDocument extends JSONDocument {
  constructor(store: DocumentStore, path: string, fileHandle: FileSystemFileHandle, format: JSONDocumentFormat) {
    super(store, path, fileHandle, format)
  }

  static isSpectralRulesetData(data: any) {
    return (
      typeof data === 'object' &&
      data !== null &&
      (('rules' in data && Array.isArray(data.rules)) ||
        ('extends' in data &&
          Array.isArray(data.extends) &&
          data.extends.some(
            (extendsValue: any) => typeof extendsValue === 'string' && extendsValue.includes('spectral')
          )))
    )
  }

  static makeSpectralRulesetDocument(document: JSONDocument) {
    if (document instanceof SpectralRulesetDocument) {
      return
    }
    Object.setPrototypeOf(document, SpectralRulesetDocument.prototype)
    document.dispatchChange()
  }
}
